import { render, staticRenderFns } from "./WhiteListedLocationsDialog.vue?vue&type=template&id=5dc97918&scoped=true&lang=pug&"
import script from "./WhiteListedLocationsDialog.vue?vue&type=script&lang=ts&"
export * from "./WhiteListedLocationsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WhiteListedLocationsDialog.vue?vue&type=style&index=0&id=5dc97918&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc97918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
